import { Pipe, PipeTransform } from '@angular/core';
import { Media } from '@quorum/models/xs-resource';

@Pipe({
  name: 'filterServiceMedia',
  pure: true,
})
export class FilterServiceMediaPipe implements PipeTransform {
  transform(media: Media[], args: { id: number; type: string }): Media[] {
    if (args.type === 'inspection') {
      return media.filter(
        (media: Media) =>
          (media.tags?.inspectionTaskId === args.id && media.customerFacing) ||
          (media.inspectionTaskId === args.id && media.customerFacing)
      );
    } else if (args.type === 'sequence') {
      return media.filter(
        (media: Media) =>
          (media.tags?.caseSequence === args.id && media.customerFacing) ||
          (media.caseSequence === args.id && media.customerFacing)
      );
    }
    return media;
  }
}
